var map = {
	"./backgroundEnglish-1.png": 11324,
	"./backgroundEnglish-2.png": 26293,
	"./backgroundHoken-1_ex.png": 47369,
	"./backgroundHoken-2_ex.png": 44070,
	"./backgroundHoken-2_ex2.png": 76054,
	"./backgroundHoken-3_ex.png": 37338,
	"./backgroundHoken-4.png": 45072,
	"./backgroundHoken-4_ex.png": 35722,
	"./backgroundHoken-4_ex2.png": 55093,
	"./bg-1.png": 73266,
	"./bg-6.png": 62370,
	"./bg-7.png": 84400,
	"./btn-1-sagasu.png": 73921,
	"./btn-1.png": 35165,
	"./btn-2-sagasu.png": 70679,
	"./btn-2.png": 82488,
	"./btn-3-sagasu.png": 65460,
	"./btn-3.png": 23988,
	"./btn-boy-sagasu.png": 76040,
	"./btn-boy.png": 42312,
	"./btn-girl-sagasu.png": 50957,
	"./btn-girl.png": 61321,
	"./btn-start.png": 90258,
	"./contents/cars/background-cars.png": 33536,
	"./contents/cars/front-cars.png": 10082,
	"./contents/contents_sagasu_hansel.png": 80576,
	"./contents/contents_sagasu_mermaid.png": 53643,
	"./contents/contents_sagasu_peterpan.png": 14167,
	"./contents/contents_seal_birthday.png": 61646,
	"./contents/contents_seal_cars.png": 72807,
	"./contents/contents_seal_dino.png": 21019,
	"./contents/contents_seal_princess.png": 33098,
	"./contents/dino/background-dino.png": 24529,
	"./contents/dino/front-dino.png": 54270,
	"./contents/hansel/background-sagasu-p4-hansel-rpa.jpg": 54185,
	"./contents/hansel/background-sagasu-p4-hansel.jpg": 89734,
	"./contents/hansel/background-sagasu-p4-hansel_body-rpa.png": 96899,
	"./contents/hansel/background-sagasu-p4-hansel_body.png": 73368,
	"./contents/hansel/background-sagasu-p5-hansel-rpa.jpg": 73484,
	"./contents/hansel/background-sagasu-p5-hansel.jpg": 77563,
	"./contents/hansel/background-sagasu-p5-hansel_body-rpa.png": 68274,
	"./contents/hansel/background-sagasu-p5-hansel_body.png": 66959,
	"./contents/hansel/cap-sagasu-p4-hansel-rpa.png": 97905,
	"./contents/hansel/cap-sagasu-p4-hansel.png": 99978,
	"./contents/hansel/cap-sagasu-p5-hansel-rpa.png": 84191,
	"./contents/hansel/cap-sagasu-p5-hansel.png": 13705,
	"./contents/hansel/front-sagasu-hansel-1.png": 50925,
	"./contents/hansel/front-sagasu-hansel-2.png": 33986,
	"./contents/hansel/front-sagasu-hansel-3.png": 76320,
	"./contents/hansel/minibody-sagasu-p5-hansel-rpa.png": 87347,
	"./contents/hansel/minibody-sagasu-p5-hansel.png": 31467,
	"./contents/hansel/minicap-sagasu-p5-hansel-rpa.png": 21602,
	"./contents/hansel/minicap-sagasu-p5-hansel.png": 78288,
	"./contents/mermaid/background-sagasu-p4-mermaid.jpg": 76889,
	"./contents/mermaid/background-sagasu-p4-mermaid_body.png": 46056,
	"./contents/mermaid/background-sagasu-p5-mermaid.jpg": 16969,
	"./contents/mermaid/background-sagasu-p5-mermaid_body.png": 90632,
	"./contents/mermaid/front-sagasu-mermaid-1.png": 48472,
	"./contents/mermaid/front-sagasu-mermaid-2.png": 32266,
	"./contents/mermaid/front-sagasu-mermaid-3.png": 86992,
	"./contents/mermaid/front-sagasu-p5-mermaid.png": 39877,
	"./contents/mermaid/minibody-sagasu-p5-mermaid.png": 45880,
	"./contents/peterpan/background-sagasu-p4-peterpan-rpa.jpg": 37907,
	"./contents/peterpan/background-sagasu-p4-peterpan.jpg": 26172,
	"./contents/peterpan/background-sagasu-p4-peterpan_body-rpa.png": 23003,
	"./contents/peterpan/background-sagasu-p4-peterpan_body.png": 39288,
	"./contents/peterpan/background-sagasu-p5-peterpan-rpa.jpg": 47374,
	"./contents/peterpan/background-sagasu-p5-peterpan.jpg": 30630,
	"./contents/peterpan/background-sagasu-p5-peterpan_body-rpa.png": 88902,
	"./contents/peterpan/background-sagasu-p5-peterpan_body.png": 28383,
	"./contents/peterpan/front-sagasu-peterpan-1.png": 92062,
	"./contents/peterpan/front-sagasu-peterpan-2.png": 7340,
	"./contents/peterpan/front-sagasu-peterpan-3.png": 73656,
	"./contents/peterpan/minibody-sagasu-p5-peterpan-rpa.png": 73899,
	"./contents/peterpan/minibody-sagasu-p5-peterpan.png": 36985,
	"./contents/peterpan/mix-sagasu-peterpan-a-rpa.png": 40049,
	"./contents/peterpan/mix-sagasu-peterpan-a.png": 57044,
	"./contents/peterpan/mix-sagasu-peterpan-b-rpa.png": 30905,
	"./contents/peterpan/mix-sagasu-peterpan-b.png": 21681,
	"./contents/princess/background-princess.png": 66721,
	"./contents/princess/front-princess.png": 7124,
	"./contents/sagasu/background-sagasu-p1.jpg": 33131,
	"./contents/sagasu/background-sagasu-p2-boy.jpg": 69731,
	"./contents/sagasu/background-sagasu-p2-boy_body.png": 77990,
	"./contents/sagasu/background-sagasu-p2-girl.jpg": 71542,
	"./contents/sagasu/background-sagasu-p2-girl_body.png": 32009,
	"./contents/sagasu/background-sagasu-p2-layer.jpg": 59064,
	"./contents/sagasu/background-sagasu-p2-layer.png": 50394,
	"./contents/sagasu/background-sagasu-p3-boy.jpg": 93937,
	"./contents/sagasu/background-sagasu-p3-boy_body.png": 77873,
	"./contents/sagasu/background-sagasu-p3-girl.jpg": 72547,
	"./contents/sagasu/background-sagasu-p3-girl_body.png": 88048,
	"./contents/sagasu/p4-line.jpg": 59761,
	"./frontHoken-1_ex.png": 70437,
	"./frontHoken-2_ex.png": 26282,
	"./frontHoken-3-1.png": 69170,
	"./frontHoken-3_ex.png": 23898,
	"./frontHoken-4.png": 57736,
	"./frontHoken-4_ex.png": 56167,
	"./frontHoken-4_ex2.png": 24428,
	"./frontHoken-4_ex3.png": 36372,
	"./frontHoken-ads-1.png": 42226,
	"./frontHoken-ads-2.png": 84730,
	"./frontHoken-ads-3.png": 33950,
	"./frontHoken-ads-4.png": 56472,
	"./icon/icon_accessory.png": 98642,
	"./icon/icon_accessory_baby.png": 19930,
	"./icon/icon_eye.png": 65804,
	"./icon/icon_eyeblows.png": 33534,
	"./icon/icon_face.png": 27023,
	"./icon/icon_hair.png": 49025,
	"./icon/icon_mouth.png": 64210,
	"./icon/icon_nose.png": 8647,
	"./indicator_01.png": 91001,
	"./indicator_02.png": 93999,
	"./indicator_03.png": 48749,
	"./menu/ic-accessory-0.png": 79435,
	"./menu/ic-accessory-1.png": 34378,
	"./menu/ic-accessory-2.png": 30311,
	"./menu/ic-accessory-3.png": 65860,
	"./menu/ic-accessory-4.png": 4424,
	"./menu/ic-accessory-5.png": 14770,
	"./menu/ic-accessory-6.png": 75972,
	"./menu/ic-accessory-7.png": 93203,
	"./menu/ic-accessory-8.png": 68317,
	"./menu/ic-accessory-9.png": 14663,
	"./menu/ic-eye-1.png": 99372,
	"./menu/ic-eye-2.png": 35343,
	"./menu/ic-eye-3.png": 53521,
	"./menu/ic-eye-4.png": 74887,
	"./menu/ic-eye-5.png": 3837,
	"./menu/ic-eye-6.png": 99931,
	"./menu/ic-eye-7.png": 4080,
	"./menu/ic-eye-8.png": 57667,
	"./menu/ic-eye-9.png": 94079,
	"./menu/ic-eyebrows-1.png": 12803,
	"./menu/ic-eyebrows-2.png": 89096,
	"./menu/ic-eyebrows-3.png": 75099,
	"./menu/ic-eyebrows-4.png": 42918,
	"./menu/ic-eyebrows-5.png": 12528,
	"./menu/ic-eyebrows-6.png": 39463,
	"./menu/ic-face-1.png": 57741,
	"./menu/ic-face-10.png": 7947,
	"./menu/ic-face-11.png": 51472,
	"./menu/ic-face-12.png": 11904,
	"./menu/ic-face-2.png": 99022,
	"./menu/ic-face-3.png": 63304,
	"./menu/ic-face-4.png": 49728,
	"./menu/ic-face-5.png": 76451,
	"./menu/ic-face-6.png": 63712,
	"./menu/ic-face-7.png": 84325,
	"./menu/ic-face-8.png": 2380,
	"./menu/ic-face-9.png": 75981,
	"./menu/ic-hair-0.png": 72401,
	"./menu/ic-hair-1.png": 28912,
	"./menu/ic-hair-10.png": 91526,
	"./menu/ic-hair-11.png": 48118,
	"./menu/ic-hair-12.png": 74327,
	"./menu/ic-hair-13.png": 5347,
	"./menu/ic-hair-14.png": 46805,
	"./menu/ic-hair-15.png": 78601,
	"./menu/ic-hair-16.png": 90018,
	"./menu/ic-hair-17.png": 49870,
	"./menu/ic-hair-18.png": 45197,
	"./menu/ic-hair-19.png": 28131,
	"./menu/ic-hair-2.png": 57572,
	"./menu/ic-hair-20.png": 45518,
	"./menu/ic-hair-21.png": 3553,
	"./menu/ic-hair-22.png": 7521,
	"./menu/ic-hair-23.png": 6001,
	"./menu/ic-hair-24.png": 2308,
	"./menu/ic-hair-25.png": 13707,
	"./menu/ic-hair-26.png": 72804,
	"./menu/ic-hair-27.png": 3183,
	"./menu/ic-hair-28.png": 79784,
	"./menu/ic-hair-29.png": 99937,
	"./menu/ic-hair-3.png": 86267,
	"./menu/ic-hair-30.png": 70167,
	"./menu/ic-hair-31.png": 71372,
	"./menu/ic-hair-32.png": 99029,
	"./menu/ic-hair-33.png": 101,
	"./menu/ic-hair-34.png": 75085,
	"./menu/ic-hair-35.png": 68946,
	"./menu/ic-hair-36.png": 94229,
	"./menu/ic-hair-37.png": 15657,
	"./menu/ic-hair-38.png": 39177,
	"./menu/ic-hair-39.png": 61076,
	"./menu/ic-hair-4.png": 46825,
	"./menu/ic-hair-40.png": 69840,
	"./menu/ic-hair-41.png": 37933,
	"./menu/ic-hair-42.png": 56531,
	"./menu/ic-hair-43.png": 47594,
	"./menu/ic-hair-44.png": 49383,
	"./menu/ic-hair-45.png": 78479,
	"./menu/ic-hair-46.png": 61681,
	"./menu/ic-hair-47.png": 34724,
	"./menu/ic-hair-5.png": 9807,
	"./menu/ic-hair-6.png": 8104,
	"./menu/ic-hair-7.png": 47805,
	"./menu/ic-hair-8.png": 11786,
	"./menu/ic-hair-9.png": 84664,
	"./menu/ic-mouth-1.png": 92545,
	"./menu/ic-mouth-2.png": 69839,
	"./menu/ic-mouth-3.png": 48134,
	"./menu/ic-mouth-4.png": 65671,
	"./menu/ic-nose-1.png": 4715,
	"./menu/ic-nose-2.png": 65596,
	"./menu/ic-nose-3.png": 80028,
	"./menu/ic-nose-4.png": 42506,
	"./menu/ic-nose-5.png": 95639,
	"./menu/ic-nose-6.png": 97665,
	"./mix-sagasu-peterpan-a.png": 58126,
	"./mix-sagasu-peterpan-b.png": 34439,
	"./no-ad-baby_front.png": 19032,
	"./no-ad-cars_front.png": 15797,
	"./no-ad-dino_front.png": 65391,
	"./no-ad-princess_front.png": 87802,
	"./og.png": 69882,
	"./parts/accessory/accessory-0.png": 31856,
	"./parts/accessory/accessory-1.png": 64827,
	"./parts/accessory/accessory-2.png": 24270,
	"./parts/accessory/accessory-3.png": 98822,
	"./parts/accessory/accessory-4.png": 61925,
	"./parts/accessory/accessory-5.png": 92745,
	"./parts/accessory/accessory-6.png": 12101,
	"./parts/accessory/accessory-7.png": 64354,
	"./parts/accessory/accessory-8.png": 92671,
	"./parts/accessory/accessory-9.png": 82201,
	"./parts/backhair/backhair-1.png": 98053,
	"./parts/backhair/backhair-10.png": 82311,
	"./parts/backhair/backhair-11.png": 80203,
	"./parts/backhair/backhair-12.png": 53590,
	"./parts/backhair/backhair-13.png": 34772,
	"./parts/backhair/backhair-14.png": 51551,
	"./parts/backhair/backhair-15.png": 42131,
	"./parts/backhair/backhair-16.png": 52115,
	"./parts/backhair/backhair-17.png": 66956,
	"./parts/backhair/backhair-18.png": 76226,
	"./parts/backhair/backhair-19.png": 65281,
	"./parts/backhair/backhair-2.png": 89116,
	"./parts/backhair/backhair-20.png": 84490,
	"./parts/backhair/backhair-21.png": 58177,
	"./parts/backhair/backhair-22.png": 58311,
	"./parts/backhair/backhair-23.png": 22628,
	"./parts/backhair/backhair-24.png": 62624,
	"./parts/backhair/backhair-25.png": 13806,
	"./parts/backhair/backhair-26.png": 78605,
	"./parts/backhair/backhair-27.png": 37588,
	"./parts/backhair/backhair-28.png": 70596,
	"./parts/backhair/backhair-29.png": 97334,
	"./parts/backhair/backhair-3.png": 42803,
	"./parts/backhair/backhair-30.png": 60671,
	"./parts/backhair/backhair-31.png": 73799,
	"./parts/backhair/backhair-32.png": 1387,
	"./parts/backhair/backhair-33.png": 27920,
	"./parts/backhair/backhair-34.png": 87195,
	"./parts/backhair/backhair-35.png": 2853,
	"./parts/backhair/backhair-36.png": 89202,
	"./parts/backhair/backhair-37.png": 77060,
	"./parts/backhair/backhair-38.png": 51017,
	"./parts/backhair/backhair-39.png": 48615,
	"./parts/backhair/backhair-4.png": 24038,
	"./parts/backhair/backhair-40.png": 42049,
	"./parts/backhair/backhair-41.png": 54049,
	"./parts/backhair/backhair-42.png": 95613,
	"./parts/backhair/backhair-43.png": 63599,
	"./parts/backhair/backhair-44.png": 92813,
	"./parts/backhair/backhair-45.png": 3657,
	"./parts/backhair/backhair-46.png": 90730,
	"./parts/backhair/backhair-47.png": 39786,
	"./parts/backhair/backhair-5.png": 98905,
	"./parts/backhair/backhair-6.png": 47988,
	"./parts/backhair/backhair-7.png": 69103,
	"./parts/backhair/backhair-8.png": 40362,
	"./parts/backhair/backhair-9.png": 50036,
	"./parts/body/body-1-B.png": 98148,
	"./parts/body/body-1.png": 13436,
	"./parts/body/body-2-B.png": 6560,
	"./parts/body/body-2.png": 84467,
	"./parts/body/body-3.png": 8298,
	"./parts/eye/eye-1.png": 85022,
	"./parts/eye/eye-2.png": 4748,
	"./parts/eye/eye-3.png": 52158,
	"./parts/eye/eye-4.png": 40016,
	"./parts/eye/eye-5.png": 69895,
	"./parts/eye/eye-6.png": 88853,
	"./parts/eye/eye-7.png": 87747,
	"./parts/eye/eye-8.png": 50198,
	"./parts/eye/eye-9.png": 31743,
	"./parts/eyebrows/eyebrows-1.png": 49302,
	"./parts/eyebrows/eyebrows-2.png": 67079,
	"./parts/eyebrows/eyebrows-3.png": 72357,
	"./parts/eyebrows/eyebrows-4.png": 15033,
	"./parts/eyebrows/eyebrows-5.png": 49196,
	"./parts/eyebrows/eyebrows-6.png": 68673,
	"./parts/face/face-1.png": 75172,
	"./parts/face/face-10.png": 30720,
	"./parts/face/face-11.png": 21838,
	"./parts/face/face-12.png": 12273,
	"./parts/face/face-2.png": 72896,
	"./parts/face/face-3.png": 25723,
	"./parts/face/face-4.png": 94568,
	"./parts/face/face-5.png": 68069,
	"./parts/face/face-6.png": 71714,
	"./parts/face/face-7.png": 39587,
	"./parts/face/face-8.png": 97656,
	"./parts/face/face-9.png": 58062,
	"./parts/hair/hair-1.png": 70886,
	"./parts/hair/hair-10.png": 71084,
	"./parts/hair/hair-11.png": 75987,
	"./parts/hair/hair-12.png": 63075,
	"./parts/hair/hair-13.png": 89032,
	"./parts/hair/hair-14.png": 3855,
	"./parts/hair/hair-15.png": 65593,
	"./parts/hair/hair-16.png": 98801,
	"./parts/hair/hair-17.png": 40270,
	"./parts/hair/hair-18.png": 3397,
	"./parts/hair/hair-19.png": 18594,
	"./parts/hair/hair-2.png": 29046,
	"./parts/hair/hair-20.png": 68091,
	"./parts/hair/hair-21.png": 32192,
	"./parts/hair/hair-22.png": 26154,
	"./parts/hair/hair-23.png": 13646,
	"./parts/hair/hair-24.png": 13921,
	"./parts/hair/hair-25.png": 98198,
	"./parts/hair/hair-26.png": 12563,
	"./parts/hair/hair-27.png": 47950,
	"./parts/hair/hair-28.png": 69430,
	"./parts/hair/hair-29.png": 9362,
	"./parts/hair/hair-3.png": 83497,
	"./parts/hair/hair-30.png": 71164,
	"./parts/hair/hair-31.png": 85536,
	"./parts/hair/hair-32.png": 49420,
	"./parts/hair/hair-33.png": 78603,
	"./parts/hair/hair-34.png": 36678,
	"./parts/hair/hair-35.png": 77015,
	"./parts/hair/hair-36.png": 46869,
	"./parts/hair/hair-37.png": 24787,
	"./parts/hair/hair-38.png": 3180,
	"./parts/hair/hair-39.png": 4322,
	"./parts/hair/hair-4.png": 93648,
	"./parts/hair/hair-40.png": 28071,
	"./parts/hair/hair-41.png": 91586,
	"./parts/hair/hair-42.png": 73574,
	"./parts/hair/hair-43.png": 77467,
	"./parts/hair/hair-44.png": 32584,
	"./parts/hair/hair-45.png": 30661,
	"./parts/hair/hair-46.png": 84927,
	"./parts/hair/hair-47.png": 76680,
	"./parts/hair/hair-5.png": 83505,
	"./parts/hair/hair-6.png": 60075,
	"./parts/hair/hair-7.png": 12303,
	"./parts/hair/hair-8.png": 22981,
	"./parts/hair/hair-9.png": 94428,
	"./parts/mouth/mouth-1.png": 46990,
	"./parts/mouth/mouth-2.png": 78929,
	"./parts/mouth/mouth-3.png": 70706,
	"./parts/mouth/mouth-4.png": 95331,
	"./parts/nose/nose-1.png": 2717,
	"./parts/nose/nose-2.png": 68816,
	"./parts/nose/nose-3.png": 18412,
	"./parts/nose/nose-4.png": 17445,
	"./parts/nose/nose-5.png": 84127,
	"./parts/nose/nose-6.png": 51526,
	"./parts/other/cheek-1.png": 33448,
	"./title-sagasu-ex.png": 85933,
	"./title-sagasu.png": 54752,
	"./title.png": 2355,
	"./top_avater_img.png": 96354,
	"./top_avater_img_baby.png": 9677,
	"./ui/ballon.png": 31147,
	"./ui/balloon-content-select.png": 40724,
	"./ui/balloon/balloon-01.svg": 82421,
	"./ui/balloon/balloon-02.svg": 26185,
	"./ui/balloon/balloon-03.svg": 65892,
	"./ui/balloon/balloon-04.svg": 5136,
	"./ui/balloon/balloon-05.svg": 96125,
	"./ui/balloon/balloon-06.svg": 77870,
	"./ui/balloon/balloon-07.svg": 30551,
	"./ui/balloon/balloon-08.svg": 70178,
	"./ui/balloon/balloon-09.svg": 32357,
	"./ui/balloon/balloon-10.svg": 47115,
	"./ui/balloon/balloon-11.svg": 98090,
	"./ui/balloon/balloon-12.svg": 7325,
	"./ui/btn/btn-baby.png": 36378,
	"./ui/btn/btn-cars.png": 31870,
	"./ui/btn/btn-dino.png": 70034,
	"./ui/btn/btn-hansel.png": 54640,
	"./ui/btn/btn-mermaid.png": 23989,
	"./ui/btn/btn-peterpan.png": 596,
	"./ui/btn/btn-princess.png": 60729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;